module.exports = __webpack_public_path__ + "img/mx.45ad2f66.png";